<template>
  <v-menu
    v-model="menuVisible"
    :position-x="posX"
    :position-y="posY"
    absolute
    :close-on-content-click="false"
    z-index="1000"
  >
    <v-card id="download_mode_card" class="d-flex flex-column" raised>
      <span class="text-h6 pa-4">  {{ $t('signatureChains.downloadMode.title') }} </span>
      <v-list
        class="document-download-options-list"
      >
        <v-list-item
          id="downloadMode_original_button"
          class="original-btn"
          link
          @click="answer( 'ORIGINAL')"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-document-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="body-1">
              {{ $t('signatureChains.downloadMode.original') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          id="downloadMode_detached_button"
          class="original-btn"
          link
          @click="answer('DETACHED')"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-certificate-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="body-1">
              {{ $t('signatureChains.downloadMode.detached') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="!newTab"
          id="downloadMode_full_button"
          class="original-btn"
          link
          @click="answer( 'FULL')"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-archive-arrow-down</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="body-1">
              {{ $t('signatureChains.downloadMode.full') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import eventBus from '@/event-bus'

export default {
  props: {

    posX: {
      type: Number,
      default: 1000
    },
    posY: {
      type: Number,
      default: 1000
    },
    visible: {
      type: Boolean,
      default: false
    },
    newTab: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answer'],
  data() {
    return {
      menuVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.menuVisible = newVal
    },
    menuVisible(newVal) {
      if (!newVal) {
        eventBus.$emit('downloadModeSelected', 'CANCEL')
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    answer(mode) {
      eventBus.$emit('downloadModeSelected', mode)
      this.menuVisible = false
    }
  }
}

</script>

<style  scoped>
</style>
